import { AuthCtx } from 'components/auth/auth-ctx';
import { PageKey } from 'enums';
import { useContext, useMemo } from 'react';

export interface PortfolioItem {
  label: string;
  key: PageKey;
  path?: string;
  subItems?: PortfolioItem[];
}

const defaultPortfolioItems = [
  {
    label: 'Badatelské listy',
    path: '/portfolio/badatelske-listy',
    key: PageKey.PORTFOLIO_RESEARCH_SHEET,
  },
  {
    label: 'Vytvořit žádost o BL',
    path: '/portfolio/badatelske-listy/novy',
    key: PageKey.PORTFOLIO_RESEARCH_SHEET_NEW,
  },
  {
    label: 'Profil',
    path: '/portfolio/profil',
    key: PageKey.PORTFOLIO_PROFILE,
  },
  {
    label: 'Zadat badatelský dotaz',
    path: '/portfolio/zadat-badatelsky-dotaz',
    key: PageKey.PORTFOLIO_RESEARCHER_NEW_ORDER,
  },
  {
    label: 'Přehled objednávek',
    path: '/portfolio/historie-objednavek',
    key: PageKey.PORTFOLIO_ORDER_HISTORY,
  },
  {
    label: 'Výpůjčky',
    key: PageKey.PORTFOLIO_LENT,
    subItems: [
      {
        label: 'Zpřístupněné digitální archiválie',
        key: PageKey.PORTFOLIO_LENT_DIGITAL,
        path: '/portfolio/vypujcky/digitalni',
      },
      {
        label: 'Papírové archiválie připravené v badatelně AUK',
        key: PageKey.PORTFOLIO_LENT_PHYSICAL,
        path: '/portfolio/vypujcky/papirove',
      },
    ],
  },
  {
    label: 'Historie výpůjček',
    key: PageKey.PORTFOLIO_LENT_HISTORY,
    subItems: [
      {
        label: 'Vrácené papírové archiválie',
        key: PageKey.PORTFOLIO_LENT_HISTORY_PHYSICAL,
        path: '/portfolio/historie-vypujcek/papirove',
      },
      {
        label: 'Vrácené digitální archiválie',
        key: PageKey.PORTFOLIO_LENT_HISTORY_DIGITAL,
        path: '/portfolio/historie-vypujcek/digitalni',
      },
      {
        label: 'Prohlédnuté archiválie pro přihlášené',
        key: PageKey.PORTFOLIO_LENT_HISTORY_REGISTERED,
        path: '/portfolio/historie-vypujcek/registered',
      },
    ],
  },
  {
    label: 'Oblíbené',
    path: '/portfolio/oblibene',
    key: PageKey.PORTFOLIO_FAVOURITE,
  },
];

export function usePortfolioItems(): PortfolioItem[] {
  const { userSheet } = useContext(AuthCtx);

  return useMemo(() => {
    if (userSheet?.id) {
      return [
        {
          label: 'Zadat badatelský dotaz',
          path: '/portfolio/zadat-badatelsky-dotaz',
          key: PageKey.PORTFOLIO_RESEARCHER_NEW_ORDER,
        },
      ];
    }

    return defaultPortfolioItems;
  }, [userSheet]);
}
